import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';

import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JhiEventManager } from 'ng-jhipster';

import { IInsuranceCompanyMySuffix } from 'src/app/shared/model/insurance-company-my-suffix.model';
import { InsuranceCompanyMySuffixService } from './insurance-company-my-suffix.service';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';


@Component({
  selector: 'jhi-insurance-company-my-suffix-access-dialog',
  templateUrl: './insurance-company-my-suffix-access-dialog.component.html',
  styleUrls: []
})
export class InsuranceCompanyMySuffixAccessDialogComponent {

  insuranceCompany: IInsuranceCompanyMySuffix;
  isConfirmed: boolean = false;

  constructor(
    private insuranceCompanyService: InsuranceCompanyMySuffixService,
    public activeModal: NgbActiveModal,
    private eventManager: JhiEventManager,
  ) { }

  clear() {
    this.activeModal.dismiss('cancel');
  }

  confirmAction(id: number) {
    this.isConfirmed = true;

    this.insuranceCompanyService.accessPlatform(id).subscribe(response => {
      this.eventManager.broadcast({
        name: 'insuranceCompanyListModification',
        content: 'Access an insuranceCompany'
      });
      this.insuranceCompany.isAccessPlatform = !this.insuranceCompany.isAccessPlatform;
      this.activeModal.dismiss(true);
    });
  }

}

@Component({
  selector: 'jhi-insurance-company-my-suffix-access-popup',
  template: ''
})
export class InsuranceCompanyMySuffixAccessPopupComponent implements OnInit, OnDestroy {
  private ngbModalRef: NgbModalRef;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private languageChangeService: LanguageChangeService
  ) { 
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
  }

  ngOnInit() {
    this.activatedRoute.data.subscribe(({ insuranceCompany }) => {
      setTimeout(() => {
        this.ngbModalRef = this.modalService.open(InsuranceCompanyMySuffixAccessDialogComponent as Component, {
          size: 'lg',
          backdrop: 'static'
        });
        this.ngbModalRef.componentInstance.insuranceCompany = insuranceCompany;
        this.ngbModalRef.result.then(
          result => {
            //this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
            this.router.navigateByUrl('', { skipLocationChange: true }).then(() => this.router.navigate(['/data-management/insurance-company']));
            this.ngbModalRef = null;
          },
          reason => {
            //this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
            this.router.navigateByUrl('', { skipLocationChange: true }).then(() => this.router.navigate(['/data-management/insurance-company']));
            this.ngbModalRef = null;
          }
        );
      }, 0);
    });
    
  }

  ngOnDestroy() {
    this.ngbModalRef = null;
  }
}
